import { render, staticRenderFns } from "./FacturaYCuentas.vue?vue&type=template&id=cc59ad88&"
import script from "./FacturaYCuentas.vue?vue&type=script&lang=js&"
export * from "./FacturaYCuentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports